var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 0C21.7324 0 28 6.26851 28 14.0001C28 21.7325 21.7324 28 14 28C6.26755 28 0 21.7324 0 14.0001C0 6.26851 6.26764 0 14 0ZM23.5395 9.19053C23.3105 8.32829 22.6358 7.64921 21.7792 7.41876C20.2264 7 14 7 14 7C14 7 7.77365 7 6.22085 7.41876C5.36419 7.64925 4.68949 8.32829 4.46049 9.19053C4.04443 10.7534 4.04443 14.0141 4.04443 14.0141C4.04443 14.0141 4.04443 17.2749 4.46049 18.8378C4.68949 19.7 5.36419 20.3508 6.22085 20.5812C7.77365 21 14 21 14 21C14 21 20.2264 21 21.7792 20.5812C22.6358 20.3508 23.3105 19.7 23.5395 18.8378C23.9556 17.2749 23.9556 14.0141 23.9556 14.0141C23.9556 14.0141 23.9556 10.7534 23.5395 9.19053ZM11.9636 11.0536L17.1676 14.0142L11.9636 16.9747V11.0536Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.6ae7810549e151965e9cb92509ca08a1.svg";
export { ForwardRef as ReactComponent };